import type { IRegisteredBusinessEntity } from "@/interfaces/api/registered-business-entity.interface.ts"
import { BaseModel } from "@/models/base.model.ts"
import { RegisteredBusinessEntityDataSources } from "@/interfaces/api/registered-business-entity.interface.ts"
import { BusinessLocation } from "@/models/business-location.model.ts"
import { ModelFactory } from "@/factories/model-factory.ts"

export class RegisteredBusinessEntity extends BaseModel implements IRegisteredBusinessEntity {
  businessLocations: BusinessLocation[]

  countryOfRegistration: string
  dataSource: RegisteredBusinessEntityDataSources
  registrationNumber: string

  name: string
  country: string

  constructor(registeredBusinessEntity: IRegisteredBusinessEntity, managed = false) {
    super(registeredBusinessEntity)

    this.businessLocations = ModelFactory.createModels(
      BusinessLocation,
      registeredBusinessEntity.businessLocations,
      managed
    )
    this.countryOfRegistration = registeredBusinessEntity.countryOfRegistration
    this.dataSource = registeredBusinessEntity.dataSource
    this.registrationNumber = registeredBusinessEntity.registrationNumber

    this.name = registeredBusinessEntity.name
    this.country = registeredBusinessEntity.country
  }

  public getMainBusinessLocation(): BusinessLocation {
    return this.businessLocations.find((bl) => bl.isMain)!
  }
}
